export class Nep21Registry {
  private providers = new Map<string, any>()
  private initialized = false

  init() {
    if (this.initialized) return

    this.initialized = true

    window.addEventListener('Neo.DapiProvider.ready', (event: any) => {
      const provider = event.detail.provider

      this.providers.set(provider.name.toLowerCase(), provider)
    })
  }

  get(name: string) {
    return this.providers.get(name.toLowerCase())
  }
}

export const nep21Registry = new Nep21Registry()
